import React from 'react';
import { Application } from '../../../models';
import { PeopleIcon } from '../../icons';
import PeopleForm from './PeopleForm';

interface EighthStepProps {
  application?: Application;
  isReadOnly?: boolean;
}

export default function EighthStep({
  application = null,
  isReadOnly = false,
}: EighthStepProps) {
  return (
    <div className="p-6 lg:py-20 lg:px-32 flex flex-col">
      <div className="w-20 h-20 rounded-full bg-[#D8FFD4] border border-[#C7FFC2] flex">
        <PeopleIcon className="h-12 w-12 m-auto text-green" />
      </div>
      <div className="mt-8">
        <h2 className="font-bold text-5xl text-neutral-600">References</h2>
        <p className="font-semibold text-2xl text-neutral-500 mt-2">
          Kindly give the names of two referees, preferably persons who have
          taught or worked with you.
        </p>
      </div>
      <PeopleForm
        application={application}
        people={application?.people ?? []}
        isReadOnly={isReadOnly}
      />
    </div>
  );
}
